import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";
import { TwoLineGridCell } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";
import formatTransactionNumber from "fe-shared-transactions/src/helpers/format";

import { InventoryAdjustment } from "../../../types/inventoryAdjustments";

interface Props extends ICellRendererParams {
  data: InventoryAdjustment;
}

const InventoryAdjustmentNumberRenderer = ({ data }: Props) => {
  return (
    <TwoLineGridCell
      firstLineData={formatTransactionNumber(data?.overallAdjustmentNumber)}
      secondLineData={null}
    />
  );
};

export default InventoryAdjustmentNumberRenderer;
